import {
  Component,
  Input,
  OnInit,
  Renderer2,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { Stepper } from '../header/header.model';
import { PODDataService } from 'src/app/core/poddata.service';
import { PreOnBoarding } from 'src/app/pages/account-request-and-pod-submission/claimant/claimant.model';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
  public stepperdata: Stepper[] = [];
  public stepperlength;
  public fullwidth = 100;
  public calculatefinaltotal;
  @Input('stepper-data') set _stepperdata(val) {
    val.forEach((x: Stepper) => {
      if (x.isActive) {
        x.path = x.activePath;
      }
      if (x.isComplete) {
        x.path = x.completePath;
      }
      if (!x.path) {
        x.path = x.inCompletePath;
      }
    });
    this.stepperdata = val;
  }

  @Output() emitStepper: EventEmitter<any>;

  constructor(public renderer: Renderer2, private el: ElementRef,private poddataService: PODDataService) {
    this.emitStepper = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.stepperlength = this.stepperdata.length;
    this.calculatefinaltotal = this.fullwidth / this.stepperlength;
  }

  fnStatus(obj: Stepper): void {
    if(sessionStorage.getItem("isEditScreenActive") != "true") {
      switch (obj.name) {
        case "Particulars of Creditor Claiming Debt":
          if(sessionStorage.getItem("isDetailsOfAuthorValid") === "true") {
            this.emitActiveStepper(obj);
          }
          break;
        
        case "Particulars of Debt":
        case "Particulars of Interest/Late Charge":
        case "Security Held":
          if((sessionStorage.getItem("isDetailsOfAuthorValid") === "true") && (sessionStorage.getItem("isDetailsOfCreditorValid") === "true")) {
            this.emitActiveStepper(obj);
          }
          else if(sessionStorage.getItem("isDetailsOfClaimantValid") === "true") {
            this.emitActiveStepper(obj);
          }
          break;
              
        case "Preview and Declare":
          if(
              (
                (sessionStorage.getItem("isDetailsOfAuthorValid") === "true") && 
                (sessionStorage.getItem("isDetailsOfCreditorValid") === "true") && 
                (this.poddataService.getClaims().particularsOfDebtClaims.length > 0 || this.poddataService.getClaims().particularsofInterest.length > 0)
              ) || 
              (
                (sessionStorage.getItem("isDetailsOfClaimantValid") === "true") && 
                (this.poddataService.getClaims().particularsOfDebtClaims.length > 0 || this.poddataService.getClaims().particularsofInterest.length > 0)
              )
            ) {
            this.emitActiveStepper(obj);
          }
          break;
        default:
          this.emitActiveStepper(obj);
          break;
      }
    }
  }
  emitActiveStepper(obj: Stepper){
    if (obj.isActive || obj.isComplete) {
      this.stepperdata.forEach((x) => {
        if (!(x.isActive === true && obj.name === x.name)) {
          if (obj.name === x.name && x.path !== obj.activePath) {
            x.path = obj.activePath;
            x.isActive = true;
            x.isComplete = false;
          } else {
            if (x.path === x.activePath || x.isComplete === true) {
              x.path = x.completePath;
              x.isActive = false;
              x.isComplete = true;
            }
          }
        }
      });
      this.emitStepper.emit(this.stepperdata);
    }
  }
}
